exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org-main[data-v-7e0bd0e2]{border-top:1px solid #dedede;height:100%}.market[data-v-7e0bd0e2],.news[data-v-7e0bd0e2]{height:calc(100% - 110px)}.cont-list[data-v-7e0bd0e2]{height:100%;overflow:auto;flex:1}.news-title[data-v-7e0bd0e2]{font-size:15px;font-weight:600;margin-bottom:1rem;max-height:40px;overflow:hidden}.news-info[data-v-7e0bd0e2]{font-size:12px;justify-content:space-between;color:#7d7d7d}.collect[data-v-7e0bd0e2]{align-items:center;justify-content:space-between}.split-info[data-v-7e0bd0e2]{height:5px}.item-info[data-v-7e0bd0e2]{width:100%;padding:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e0bd0e2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/overview/NewsList.vue
// module id = 848
// module chunks = 0